var map = {
	"./3 001.jpg": 3955,
	"./BDS_8218.jpg": 4092,
	"./BDS_8221.jpg": 3224,
	"./Bava's Visit (1).jpeg": 6557,
	"./Bava's Visit (3).jpeg": 5039,
	"./Bava's Visit (4).jpeg": 9356,
	"./Bava's Visit (5).jpeg": 2921,
	"./cataract.jpg": 6214,
	"./diodelaser.jpg": 3031,
	"./eyecamp1.jpg": 4304,
	"./eyecamp2.jpg": 4623,
	"./eyecamp3.jpg": 8242,
	"./first.jpg": 4267,
	"./inau.jpg": 7902,
	"./kalpetta.jpg": 4207,
	"./laser.jpg": 1548,
	"./mobileclininc.jpg": 5951,
	"./nethra.jpg": 7357,
	"./nethra1.jpg": 8548,
	"./skmj.jpg": 2218,
	"./skmj2.jpg": 3002,
	"./skmj3.jpg": 5159,
	"./specs.jpg": 1533,
	"./visit1.jpg": 9075,
	"./visit2.jpg": 3012,
	"./visit3.jpg": 1169
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4546;